export class Pair<T, U> {
    First: T;
    Second: U;

    constructor(first: T, second: U) {
        this.First = first;
        this.Second = second;
    }
}
